export default __webpack_public_path__ + "static/media/img-hero-desktop-01-classic.0440aa41.jpg";